import Component from "@glimmer/component";
import { cached } from "@glimmer/tracking";
import { service } from "@ember/service";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { string } from "prop-types";

@forbidExtraArgs
export default class DataCenter extends Component {
  @service store;

  @arg(string.isRequired) dataCenter;

  @cached
  get match() {
    const value = this.dataCenter;
    const dataCenters = this.store.peekAll("data-center");

    return (
      dataCenters.find((dataCenter) => dataCenter.id === value) ??
      dataCenters.find((dataCenter) => dataCenter.name === value)
    );
  }

  <template>
    <span data-test-data-center ...attributes>
      {{#if this.match}}
        <span data-test-data-center-name>{{this.match.name}}</span>
        <span class="text-gray-500" data-test-data-center-key>({{this.match.id}})</span>
      {{else}}
        {{this.dataCenter}}
      {{/if}}
    </span>
  </template>
}
